import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ICompensation } from '../models/ICompensation.model';
import { ICompensationType } from '../models/ICompensationType.model';
import { IPhoneType } from '../models/IPhoneType.model';
import { IPositionType } from '../models/IPositionType.model';
import { ITimeZone } from '../models/ITimeZone.model';

@Injectable()
export class CommonService {

  constructor(private http: HttpClient) { }

  getPhoneTypes(): Observable<IPhoneType[]> {
    return this.http.get<IPhoneType[]>(`${environment.portalBase}common/get-phone-types`);
  }

  getTimeZones(): Observable<ITimeZone[]> {
    return this.http.get<ITimeZone[]>(`${environment.portalBase}common/get-time-zones`);
  }

  getCompensationTypes(positionTypeId: number): Observable<ICompensationType[]> {
    return this.http.get<ICompensationType[]>(`${environment.portalBase}common/get-compensation-types/${positionTypeId}`);
  }

  getCompensations(compensationTypeId: number): Observable<ICompensation[]> {
    return this.http.get<ICompensation[]>(`${environment.portalBase}common/get-compensations/${compensationTypeId}`);
  }

  getPositionTypes(): Observable<IPositionType[]> {
    return this.http.get<IPositionType[]>(`${environment.portalBase}common/get-position-types`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts